export default Object.freeze({
  STUDENT_LOCATION: 0,
  SERVICE_SELECTION: 1,
  CONFIRM_INFO: 2,
  END: 3,
});
